import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import s from './CloseIcon.scss'


const CloseIcon = ({ className, red, color, size, onClick }) => (
  <span
    className={cx(s.closeIcon, className, {
      [s.red]: red,
      [s[color]]: color,
      [s[`size_${size}`]]: size,
    })}
    onClick={onClick}
  />
)

CloseIcon.propTypes = {
  className: PropTypes.string,
  red: PropTypes.bool,
  color: PropTypes.string,
  onClick: PropTypes.func,
}


export default CloseIcon
